<template>
<!-- v-if="pageId==='16'" -->
	<div  class="function_wrap" id='function_wrap'>
            <consult v-if="!isPhone"></consult>
            <div :class=" !isPhone? 'function_wrap box':'function_wrap box_mobile' " id='function_box0' style="background-color: #fff;">
                <!-- <div class="function_wrap_title">人损赔偿(含交通)计算器</div> -->
                <h1 class="function_wrap_title" style=" height:auto ">交通事故赔偿计算器|人损赔偿计算器</h1>
                <div class="function_wrap_title_EN">PERSONAL INJURY CALCULATOR</div>
               
               
                <el-form ref="form" :model="form" :label-width="isPhone? '90px' :'160px'" style="margin-top:20px;  ">
                    <el-form-item label="伤残等级1"  >
                        <el-select v-model="form.injury_level0" placeholder="请选择伤残等级" style="min-width:300px; max-width:400px">
                            <el-option
                                v-for="item in kind"
                                :label="item.title"
                                :key="item.title"
                                :value="item.injury_level">
                            </el-option>
                        </el-select>

                        <!-- <el-button  icon="el-icon-plus" circle  style="text-align:center"></el-button> -->

                    </el-form-item>


       
 

                     

                    <el-form-item label="伤残等级2"  >
                        <el-select v-model="form.injury_level1" placeholder="如只有一个伤残等级，则该项可不填"  style="min-width:300px; max-width:400px">
                            <el-option
                                v-for="item in kind"
                                :label="item.title"
                                :key="item.title"
                                :value="item.injury_level">
                            </el-option>
                        </el-select>

                        
                    </el-form-item>

                    
                    <el-form-item label="伤残等级3"  >
                        <el-select v-model="form.injury_level2" placeholder="如只有一个伤残等级，则该项可不填"  style="min-width:300px; max-width:400px">
                            <el-option
                                v-for="item in kind"
                                :label="item.title"
                                :key="item.title"
                                :value="item.injury_level">
                            </el-option>
                        </el-select>

                        
                    </el-form-item>

                   

                    <el-form-item label="年龄">
                        <el-input v-model="form.age"  style="min-width:300px; max-width:400px"></el-input>
                    </el-form-item>

                    <el-form-item label="所在地区">
                        <el-select v-model="form.area" placeholder="请选择所在地区"  style="min-width:300px; max-width:400px">
                         <el-option
                            v-for="item in kind2"
                            :key="item"
                            :value="item">
                        </el-option>
                    </el-select>
                    </el-form-item>

                    <!-- <el-form-item label="活动时间" required>
                     
                    </el-form-item> -->
                    <el-col :span="10">
                        <el-form-item label="住院天数">
                            <el-input v-model="form.days" placeholder="住院天数"></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="10">
                        <el-form-item label="医疗费">
                            <el-input v-model="form.medical_fee" placeholder="医疗费"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="10">
                        <el-form-item label="误工期">
                            <el-input v-model="form.work_days" ></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="10">
                        <el-form-item label="护理期">
                            <el-input v-model="form.nursing_days"  ></el-input>
                        </el-form-item>
                    </el-col>

                     <el-col :span="10">
                        <el-form-item label="营养期">
                            <el-input v-model="form.nutrition_days" ></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :span="10">
                        <el-form-item label="当事人平均工资">
                            <el-input v-model="form.my_ava_wage"  ></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="10">
                        <el-form-item label="被抚养人数">
                            <el-input v-model="form.people_need_raised" type="number" :maxlength="1" @input="set_people_need_raised" ></el-input>
                        </el-form-item>
                    </el-col>
                    
                    <div v-if="form.people_need_raised>0">
                        <el-col :span="10" >
                            <el-form-item label="有抚养义务的人">
                                <el-input v-model="form.people_should_raise"  ></el-input>
                            </el-form-item>
                        </el-col>

                        <!-- v-for="(item ,index) in  form.people_need_raised_ages"  v-bind:key="index" -->
                        <el-col :span="10" v-for="(item ,index) in  form.people_need_raised_ages"  v-bind:key="index">
                            <el-form-item :label="'被抚养人'+(index+1)+'年纪'">
                                <el-input v-model="form.people_need_raised_ages[index]"  ></el-input>
                            </el-form-item>
                        </el-col>
                    </div>
                    <!-- people_should_raise -->


                </el-form> 


                <!-- <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item label="住院天数">
                        <el-input v-model="formInline.user" placeholder="审批人"></el-input>
                    </el-form-item>
                    <el-form-item label="住院天数">
                        <el-input v-model="formInline.user" placeholder="审批人"></el-input>
                    </el-form-item>
                </el-form> -->
               
               
                <!-- <div class='optionitem' >   

                    
                    <div class="optionitem item_name">伤残等级：</div>
                    <div  class="optionitem item_detail" >
                        <el-select v-model="index" placeholder="请选择" style="width:100%;" >
                            <el-option
                                v-for="item in kind"
                                :key="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </div>

                </div>     -->
                <!-- <div class='optionitem' >   
                    <div class="optionitem item_name" >输入年龄：</div>
                    <div style="width:70%;"> <el-input type='number' min=0 v-model="inputValue" placeholder="请输入年龄"></el-input> </div>   
                </div>   -->
                <!-- <div class='optionitem' >   
                    <div class="optionitem item_name">所在地区：</div>
                    <div  class="optionitem item_detail" >
                        <el-select v-model="index2" placeholder="请选择" style="width:100%;" >
                            <el-option
                                v-for="item in kind2"
                                :key="item"
                                :value="item">
                            </el-option>
                        </el-select>       
                    </div>
                </div>    -->
                <!-- <div class='optionitem' >   
                        <div class="optionitem item_name">城镇/农村：</div>
                        <div  class="optionitem item_detail" >
                            <el-select v-model="index3" placeholder="请选择" style="width:100%;" >
                                <el-option
                                    v-for="item in kind3"
                                    :key="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </div>
                </div>   -->
                <!-- <div class="addParam" @click="AddParamHandle">  <span>添加详细参数</span> <i class="el-icon-circle-plus"></i> </div> -->


                <div style="width:90%">
                    <span  class="guide" @click="AddParamHandle">设置自定义参数</span>
                </div>

                <div  style="margin-top:60px">
                    <el-row>
                        <!-- @click="CalculateHandle" -->
                         <!-- @click="submitForm('form')"  -->
                        <el-button @click="CalculateHandle"  type="primary" style="width:130px">确定</el-button>
                        <!-- <el-button @click="AddParamHandle" type="warning" style="margin-left: 50px;width:130px">设置自定义参数</el-button> -->
                    
                        <el-switch
                            style="margin-left: 50px;margin-right:10px "
                            v-model="useMine"
                            active-color="#13ce66"
                          
                         >
                        </el-switch>
                        <span>{{useMine?'':'不' }}使用自定义参数</span>

                    </el-row>
                </div>

                <div class="result">
                    <h4>计算结果：</h4>
                    <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;计算结果仅供参考。计算仅考虑全责情况，默认数据仅考虑城镇，更多常用参数可以在常用参数设置里进行固定。 由于需要存储常用参数，未登录用户可能无法正常使用。</p>
                    <!-- <p v-cloak style="margin-top:5px;">&nbsp;&nbsp;&nbsp;&nbsp;
                        您目前选择所在地区{{form.area}} 上一年度城镇居民人均可支配收入：{{data1[form.area].ava_income1}} (我的设置：{{param.ava_income}})   受诉法院所在地上一年度城镇居民人均消费性支出：{{data1[form.area].ava_consuming_fee1}}   (我的设置：{{param.ava_consuming_fee}})  (<span style="font-weight:bold">当你设置了常用参数中的该两项且值不为0，系统默认使用常用参数设置中的数值</span>) 
                    </p> -->

                    <!-- <p style="font-weight:bold;color:#000000 ">江苏地区请注意：根据2020年江苏高院发布的新规定，计算方式做了与其他地区不同的特殊处理，需要该地区用户自行计算，具体公式如下：</p> -->
                    <p>　 残疾赔偿金=（上一年度全省居民人均工资性收入+上一年度全省居民人均经营净收入）×上一年度全省平均负担系数×劳动力丧失比例×20年（六十周岁以上的，年龄每增加一岁减少一年；七十五周岁以上的，按五年计算）</p>
                    <p>   死亡赔偿金=（上一年度全省居民人均工资性收入+上一年度全省居民人均经营净收入）×上一年度全省平均负担系数×20年（六十周岁以上的，年龄每增加一岁减少一年；七十五周岁以上的，按五年计算） </p>
      
                 
                </div>  

                <el-table
                    :data="tableData"
                    stripe
                    style="width: 100%">
                    <el-table-column
                    prop="name"
                    label="类目"
                     >
                    </el-table-column>
                    <el-table-column
                    prop="result"
                    label="结果"
                    >
                    </el-table-column>
                    <!-- <el-table-column
                        prop="address"
                        label="地址">
                    </el-table-column> -->
                </el-table>







                <el-dialog title="设置常用参数" :visible.sync="dialogFormVisible">
                    <el-form :model="param">
                        <el-form-item  label="上一年度城镇(或农村)居民人均可支配收入" label-width="300px">
                            <el-input v-model="param.ava_income" autocomplete="off" style="width:200px"></el-input>
                        </el-form-item>
                        <el-form-item  label="受诉法院所在地上一年度城镇(或农村)居民人均消费性支出" label-width="300px">
                            <el-input v-model="param.ava_consuming_fee" autocomplete="off" style="width:200px"></el-input>
                        </el-form-item>
                        <el-form-item  label="当地护理费标准/日" label-width="300px">
                            <el-input v-model="param.nurse_subsidy" autocomplete="off" style="width:200px"></el-input>
                        </el-form-item>
                        <el-form-item  label="伙食补助地方标准/日" label-width="300px">
                            <el-input v-model="param.food_subsidy" autocomplete="off" style="width:200px"></el-input>
                        </el-form-item>
                        <el-form-item  label="营养费地方补助标准/日" label-width="300px">
                            <el-input v-model="param.nutition_subsidy" autocomplete="off" style="width:200px"></el-input>
                        </el-form-item>
                        <el-form-item  label="上年度在岗职工平均工资" label-width="300px">
                            <el-input v-model="param.ava_wage" autocomplete="off" style="width:200px"></el-input>
                        </el-form-item>
                        <!-- <el-form-item label="活动区域" :label-width="formLabelWidth">
                        <el-select v-model="form.region" placeholder="请选择活动区域">
                            <el-option label="区域一" value="shanghai"></el-option>
                            <el-option label="区域二" value="beijing"></el-option>
                        </el-select>
                        </el-form-item> -->
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false" style="margin-right:50px">取 消</el-button>
                        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
                    </div>
                </el-dialog>

            </div>   
        </div>
</template>

<script>
function isphone() {
	var sUserAgent = navigator.userAgent.toLowerCase();
	var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
	var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
	var bIsMidp = sUserAgent.match(/midp/i) == "midp";
	var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
	var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
	var bIsAndroid = sUserAgent.match(/android/i) == "android";
	var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
	var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
	if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid
			|| bIsCE || bIsWM) {
		return true
	} else {
		return false
	}
}

 import consult from '@/components/ads/consult.vue' 

 import { IncUseNumber } from '@/assets/js/cal/cal';  

	export default {
        name: 'traffic',
        metaInfo: {
            title: '交通事故赔偿计算器|人身损害赔偿计算器', // set a title
            meta: [{                 // set meta
                name: 'keywords',
                content: '交通事故赔偿计算,交通事故律师,人身伤害赔偿计算,侵权律师'
            }],
      
        },
        props: {
            // isPhone: Boolean
        },
        components: { 
            consult
        
        },
        mounted: function () {
            this.isPhone=isphone()
            IncUseNumber('traffic')

            var that=this
            var data= { 
                whattodo: "getTraffic"
            }
            this.axios.post('https://api.lawtip.cn/cal',data
            ).then(function (res) {
                window.console.log(res)
                if(res.status==200){
                    let result=res.data
                    if(result.status=='badgate'){
                        that.$message({
                            message: '请先登录哦',
                            type: 'warning'
                        });

                    }else if (result.status=='ok'){
                    //    sessionStorage.setItem('traffic', JSON.stringify(result.data));
                        that.param=result.data

                    }else if (result.status=='noresult'){
                        that.$message('没有查询到结果');
                    }


                    
                }
                
            
                
            }).catch(function (error) {
                window.console.log(error);
            });

        },
        data() {
			return { 
                // kind: ['死亡', '一级', '二级', '三级', '四级', '五级', '六级', '七级', '八级', '九级', '十级'],
                useMine:false,
                kind: [{ 'title': '死亡', "injury_level": 0.1, "code": 0.1 }, { 'title': '一级', "injury_level": 1, "code": 1 }, { 'title': '二级', "injury_level": 2, "code": 0.9 }, { 'title': '三级', "injury_level": 3 }, { 'title': '四级', "injury_level":4 }, { 'title': '五级', "injury_level": 5 }, { 'title': '六级', "injury_level": 6 }, { 'title': '七级', "injury_level": 7 }, { 'title': '八级', "injury_level": 8 }, { 'title': '九级', "injury_level": 9 }, { 'title': '十级', "injury_level": 10 }  ],
                index:'死亡',
                inputValue:'20',
                // kind2: ['江苏省', '广东省', '浙江省', '北京市', '上海市', '广西省', '山东省', '福建省', '四川省', '河北省', '河南省', '辽宁省', '黑龙江省', '内蒙古省', '重庆市', '安徽省', '湖北省', '湖南省', '海南省', '天津市', '云南省',  '山西省', '陕西省', '西藏', '贵州省', '甘肃省', '青海省', '宁夏', '新疆'],
                // kind2: ['江苏', '广东', '浙江', '北京', '上海', '广西', '山东', '福建', '四川', '河北', '河南', '辽宁', '黑龙江', '内蒙古', '重庆', '安徽', '湖北', '湖南', '海南', '天津', '云南',  '山西', '陕西', '西藏', '贵州', '甘肃', '青海省', '宁夏', '新疆'],
                kind2: ['江苏', '广东', '浙江', '北京', '上海', '广西', '山东', '福建', '四川', '河北', '河南', '辽宁', '黑龙江', '内蒙古', '重庆', '安徽', '湖北', '湖南', '海南', '天津', '云南',  '山西', '陕西', '西藏', '贵州', '甘肃', '青海省', '宁夏', '新疆','江西','吉林'],
                index2: '上海市',
                kind3: ['城镇', '农村'],
                index3:'城镇',
                city1_income:'',
                city2_income:'',   
                result:'',
                o1:'',
                o2:'',
                o3:'',
                work_fee:'平均工资x误工期',
                mental_fee:0,
                nurse_fee: '当地每日护理费标准x护理期',
                funeral_fee:'上年度在岗职工平均工资(城镇)÷12个月×6个月',
                food_fee: '当地每日住院伙食费标准x护理期',
                nutrition_fee: '当地每日住院营养费标准x护理期',
                traffic_fee:'根据实际发票计算',
                maintenance:'上年度农民家庭人均生活费支出x系数x年数÷对被抚养人承担扶养义务的人数',
                medical_fee: '根据实际发票计算',
                authenticate_fee: '根据实际发票计算',
                tableData:[],
                isPhone:false,
                // tableData: [{
                //     name: '伤残赔偿金',
                //     result: ''
                //     }, {
                //     name: '误工费',
                //     result: ''
                //     }, {
                //     name: '护理费',
                //     result: ''
                //     }, {
                //     name: '伙食费',
                //     result: ""
                //     }, {
                //     name: '营养费',
                //     result: ''
                //     }, {
                //     name: '交通费',
                //     result: ''
                //     }, {
                //     name: '精神损失抚慰金',
                //     result: ''
                //     }, {
                //     name: '鉴定费',
                //     result: ''
                //     }, {
                //     name: '医疗费',
                //     result: ''
                //     }, {
                //     name: '丧葬费',
                //     result: ''
                //     }, {
                //     name: '被扶养人生活费',
                //     result: ''
                // }]

                // 人均可支配收入
                data1: {
                    "江苏": { "ava_income1": 60178, "ava_income2": 28486 , "ava_consuming_fee1": 37796, "ava_consuming_fee2": 22597 ,"year": 2023 , source:'http://tj.jiangsu.gov.cn/art/2023/3/3/art_87595_10787029.html'  }, 
                    "广东": { "ava_income1": 56905, "ava_income2": 23598, "ava_consuming_fee1": 36936, "ava_consuming_fee2": 20800 ,"year": 2023 , source:'http://stats.gd.gov.cn/tjgb/content/post_4146083.html'    },
                    "上海": { "ava_income1": 84034, "ava_income2": 39729, "ava_consuming_fee1": 48111, "ava_consuming_fee2": 27430 ,"year": 2023, source: 'https://www.cet.com.cn/dfpd/dfjj/3345204.shtml'  },
                    "浙江": { "ava_income1": 71268, "ava_income2": 37565, "ava_consuming_fee1": 44511, "ava_consuming_fee2": 27483 ,"year": 2023,source: 'http://tjj.zj.gov.cn/art/2023/3/16/art_1229129205_5080307.html'  },
                    "安徽": { "ava_income1": 45133, "ava_income2": 19575, "ava_consuming_fee1": 26832, "ava_consuming_fee2": 17980 ,"year": 2023,souce:'http://tjj.ah.gov.cn/ssah/qwfbjd/tjgb/sjtjgb/147903181.html'},
                    "北京": { "ava_income1": 84023, "ava_income2": 34754, "ava_consuming_fee1": 45617, "ava_consuming_fee2": 23745,"year": 2023,souce:'http://tjj.beijing.gov.cn/zxfbu/202303/t20230320_2940009.html' },
                    "福建": { "ava_income1": 53817, "ava_income2": 24987, "ava_consuming_fee1": 35692, "ava_consuming_fee2": 20467 ,"year": 2023,souce:'http://xxzx.fujian.gov.cn/jjxx/tjxx/202303/t20230313_6130081.htm'},
                    "四川": { "ava_income1": 43233, "ava_income2": 18672, "ava_consuming_fee1": 27637, "ava_consuming_fee2": 18672 ,"year": 2023,souce:'https://www.sc.gov.cn/10462/c108715/2023/3/22/5d2ee2bb1c0c45088d011638934d0cfa.shtml'},
                    "重庆": { "ava_income1": 45509, "ava_income2": 19313, "ava_consuming_fee1": 30574, "ava_consuming_fee2": 16727 ,"year": 2023 ,souce:'http://www.cq.gov.cn/zjcq/sjfb_120853/tjgb/202303/t20230320_11785098.html'},
                    "云南": { "ava_income1": 42168, "ava_income2": 15147, "ava_consuming_fee1": 26240, "ava_consuming_fee2": 13309 ,"year": 2023,souce:'https://www.yn.gov.cn/sjfb/tjgb/202303/t20230328_256987.html'},
                    "湖北": { "ava_income1": 42626, "ava_income2": 19709, "ava_consuming_fee1": 29121, "ava_consuming_fee2": 18991,"year": 2023 ,source:'http://www.hubei.gov.cn/zwgk/hbyw/hbywqb/202303/t20230318_4589713.shtml' },
                    "湖南": { "ava_income1": 42432, "ava_income2": 19546, "ava_consuming_fee1": 29580, "ava_consuming_fee2": 18078  ,"year": 2023,source:'http://www.hunan.gov.cn/hnszf/zfsj/tjgb/202303/t20230323_29297460.html'  },
                    "黑龙江": { "ava_income1": 35042, "ava_income2": 18577, "ava_consuming_fee1": 24011, "ava_consuming_fee2": 15162 ,"year": 2023,source:'https://baijiahao.baidu.com/s?id=1761030115473479725&wfr=spider&for=pc'},
                    "河北": { "ava_income1": 41278, "ava_income2": 19364, "ava_consuming_fee1": 25071, "ava_consuming_fee2": 16271 ,"year": 2023,source:'http://www.hetj.gov.cn/cms/preview/hetj/app/tjgb/101672190375289.html'},
                    "河南": { "ava_income1": 38484, "ava_income2": 18697, "ava_consuming_fee1": 23539, "ava_consuming_fee2": 14824 ,"year": 2023,source:'https://www.henan.gov.cn/2023/03-23/2711902.html'},
                    "辽宁": { "ava_income1": 44003, "ava_income2": 19908, "ava_consuming_fee1": 0, "ava_consuming_fee2": 0 ,"year": 2023,source:'http://district.ce.cn/newarea/roll/202303/30/t20230330_38471825.shtml'},
                    "内蒙古": { "ava_income1": 46295, "ava_income2": 19641, "ava_consuming_fee1": 26667, "ava_consuming_fee2": 15444 ,"year": 2023,source:'https://www.nmg.gov.cn/tjsj/sjfb/tjsj/tjgb/202303/t20230316_2274533.html?dzb=true'},
                    
                    "吉林": { "ava_income1": 35471, "ava_income2": 18134, "ava_consuming_fee1": 21835, "ava_consuming_fee2": 12729,"year": 2023,source:'http://tjj.jl.gov.cn/tjsj/tjgb/ndgb/202304/t20230401_8687326.html' },
                    "广西": { "ava_income1": 39703, "ava_income2": 17433, "ava_consuming_fee1": 22438, "ava_consuming_fee2": 14658 ,"year": 2023,source:'http://tjj.gxzf.gov.cn/syyw/t16224266.shtml' },
                    "山东": { "ava_income1": 49050, "ava_income2": 22110, "ava_consuming_fee1": 28555, "ava_consuming_fee2": 14687,"year": 2023,source:'http://tjj.shandong.gov.cn/art/2023/3/2/art_6196_10303466.html'  },
                    "海南": { "ava_income1": 40118, "ava_income2": 19117, "ava_consuming_fee1": 26418, "ava_consuming_fee2": 15145,"year": 2023,source:'https://www.hainan.gov.cn/hainan/ndsj/202302/ca8dec78f2394f1c906d6cdf8984662a.shtml' },
                    
                    "天津": { "ava_income1": 53003, "ava_income2": 29018, "ava_consuming_fee1": 0, "ava_consuming_fee2": 0 ,"year": 2023,source:'https://www.tj.gov.cn/sq/tjgb/202303/t20230317_6142972.html'},
                    "山西": { "ava_income1": 39532, "ava_income2": 16323, "ava_consuming_fee1": 21923, "ava_consuming_fee2": 12091,"year": 2023,source:'http://www.shanxi.gov.cn/zjsx/zlssx/shjj/202203/t20220324_6045043.shtml' },
                    "陕西": { "ava_income1": 42431, "ava_income2": 15704, "ava_consuming_fee1": 24766, "ava_consuming_fee2": 14094,"year": 2023,source:'http://gxt.shaanxi.gov.cn/ygzdt/89407.jhtml' },
                    "贵州": { "ava_income1": 39211, "ava_income2": 16021, "ava_consuming_fee1": 25333, "ava_consuming_fee2": 13328 ,"year": 2022},

                    "甘肃": { "ava_income1": 37572.4, "ava_income2": 12165.2, "ava_consuming_fee1": 25207, "ava_consuming_fee2": 13328 ,"year": 2022},
                    "青海": { "ava_income1": 39244, "ava_income2": 16021, "ava_consuming_fee1": 25386, "ava_consuming_fee2": 11494.2 ,"year": 2023 ,source:'https://baijiahao.baidu.com/s?id=1761574641798179761&wfr=spider&for=pc' },
                    "宁夏": { "ava_income1": 38291, "ava_income2": 16021, "ava_consuming_fee1": 28063, "ava_consuming_fee2": 13328 ,"year": 2022},

                    "新疆": { "ava_income1": 38410, "ava_income2": 16550, "ava_consuming_fee1": 24142, "ava_consuming_fee2": 12169,"year": 2023,source:'http://www.xinjiang.gov.cn/xinjiang/tjgb/202303/a527e6eb22524c40bc7fca952a05710e.shtml'},
                    "台湾": { "ava_income1": 39244, "ava_income2": 16021, "ava_consuming_fee1": 28063, "ava_consuming_fee2": 13328 },
                    "江西": { "ava_income1": 43697, "ava_income2": 19936, "ava_consuming_fee1": 25976, "ava_consuming_fee2": 16984 ,"year": 2023,source:'http://tjj.jiangxi.gov.cn/art/2023/3/28/art_38773_4403038.html' },
                    "吉林": { "ava_income1": 35471, "ava_income2": 18134, "ava_consuming_fee1": 21835, "ava_consuming_fee2": 12729 ,"year": 2023,source:'http://tjj.jl.gov.cn/tjsj/tjgb/ndgb/202304/t20230401_8687326.html' }
                    //平均值
                    //城镇居民人均可支配收入39244元；农村居民人均可支配收入16021元。
                    //城镇居民人均生活消费支出28063元；农村居民人均生活消费支出13328元。
                },
                dialogFormVisible: false,
                form: {
                    area:'上海',
                    age: 20,
                    injury_level0: 0.1,
                    days:0,

                    medical_fee:0,
                    my_ava_wage:0,
                    nursing_days: 0,
                    nutrition_days: 0,
                    people_need_raised: 0,
                    work_days:0,
                    people_need_raised_ages:[0],
                    people_should_raise:1,
               
                    
                },
                // formLabelWidth: '80px',
                param:{
                    "ava_consuming_fee":0,
                    "ava_income":0,
                    "ava_wage":0,
                    "food_subsidy":0,
                    "nurse_subsidy":0,
                    "nutition_subsidy":0

                },
                // params:{}
            }

        },
        
    methods:{
        AddParamHandle(){
            this.dialogFormVisible=true
        },

        set_people_need_raised(e){
            window.console.log('e:',e)

            if (e<0){
                this.$message({
                    message: '需大于等于0',
                    type: 'warning'
                });

                return
            }
            if(e>9){
                e=9
            }
            
            var a=[]
            for (let i = 0; i < e;i++){
                a[i]=0
            } 
            this.form.people_need_raised=e
            this.form.people_need_raised_ages=a

            // this.setData({
            // "param.people_need_raised": e.detail.value,
            // "param.people_need_raised_ages":a
            // })


        },

        resetEvent(){
            this.inputValue='';
            this.city1_income='';
            this.city2_income='';
            this.tableData= [{
          name: '伤残赔偿金',
          result: ''
        }, {
          name: '误工费',
          result: ''
        }, {
          name: '护理费',
          result: ''
        }, {
          name: '伙食费',
          result: ""
        }, {
          name: '营养费',
          result: ''
        }, {
          name: '交通费',
          result: ''
        }, {
          name: '精神损失抚慰金',
          result: ''
        }, {
          name: '鉴定费',
          result: ''
        }, {
          name: '医疗费',
          result: ''
        }, {
          name: '丧葬费',
          result: ''
        }, {
          name: '被扶养人生活费',
          result: ''
        }];

        },


 

        bindcalculate:function(){

            // var that=this;
            document.getElementById('function_wrap').style.height="1300px";
            document.getElementById('function_box0').style.height="1200px";

            let t,age;
            let income1,income2; //income
      
            let disable;

            var age1=this.inputValue;
            var city=this.index3;
            switch (this.index)
            {
            case '死亡':
                t=1;
                break;
            case '一级':
                t=1;
                break;
            case '二级':
                t=0.9;
                break;
            case '三级':
                t=0.8;
                break;
            case '四级':
                t=0.7;
                break;
            case '五级':
                t=0.6;
                break;
            case '六级':
                t=0.5;
                break;
            case '七级':
                t=0.4;
                break;
            case '八级':
                t=0.3;
                break;
            case '九级':
                t=0.2;
                break;
            case '十级':
                t = 0.1;
                break;  
            default:
                t=1;

            }

            if(age1<=60){
                age=20;

            }
            else if(age1>75){
                age=5;
            }
            else if(age1>60 && age1<=75){
                age=20-(age1-60);
            }

       

            switch (this.index2) {
            case '江苏省':  
                income1 = 47200;
                income2=20845;
            
                break;
            case '广东省':   
                    income1 = 44341;
                    income2 = 17168;

             
                break;
            case '浙江省':       
                    income1 = 55574;
                    income2 = 27302;

              
                break;
            case '北京市':  
                    income1 = 67990;
                    income2 = 24240;  

            
             
                break;
            case '上海市':  
                income1 = 68034;   
                income2 = 30375;  

          
                break;
            case '广西省':  
                    income1 = 30502;   
                    income2 = 11325; 
 
                break;
            case '山东省':  
                    income1 = 39549;
                    income2 = 16297;
 
                break;
            case '福建省':   
                    income1 = 42121;
                    income2 = 17821;


       
                break;
            case '四川省':  
                    income1 = 33216;
                    income2 = 13331;
          
                break;
            case '河北省':  
                    income1 = 32997;
                    income2 = 14031;
 
                break;
            case '河南省':   
                    income1 = 29557.86;
                    income2 = 12719.18;  
 
                break;
            case '辽宁省':  
                    income1 = 37342;
                    income2 = 14656;


          
                break;
            case '黑龙江省':   
                    income1 = 29191;
                    income2 = 13804;
 
                break;
            case '内蒙古省':   
                    income1 = 38305;
                    income2 = 13803;   
 
                break;
            case '重庆市':   
                    income1 = 34889;
                    income2 = 13781;
 
                break;
            case '安徽省':   
                    income1 = 34393;
                    income2 = 13996;

       
                break;
            case '湖北省':   
                    income1 = 34455;
                    income2 = 14978;

           
                break;
            case '湖南省':   
                    income1 = 36698;
                    income2 = 14093;

  
                break;
            case '海南省':   
                    income1 = 33349;
                    income2 = 13989;
 
                break;
            case '天津市':  
                    income1 = 42976;
                    income2 = 23065;
 
                break;

            case '云南省':   
                income1 = 33488;
                income2 = 10768;

           
            break;

                case '山西省':  
                    income1 = 31035;
                    income2 = 11750;

      
                break;

                case '陕西省':  
                    income1 = 33319;
                    income2 = 11213;
 
                break;

                case '西藏':  
                    income1 = 28228;
                    income2 = 10330;   

   
                break;

                case '贵州省':  
                    income1 = 31592;
                    income2 = 9716 ;  
 
                break;

                case '甘肃省':   
                    income1 = 29957;
                    income2 = 8804;

    
                break;

                case '青海省':  
                    income1 = 29169;
                    income2 = 9462;
 
                break;

                case '宁夏':   
                    income1 = 31895;
                    income2 = 11708;

      
                break;


                default:
                    income1 = 43622;
                    income2 = 19158;


                }

                if(city=='城镇'){
                    disable = income1*t*age;
                    this.o1=income1;
          

                }
                else if(city=='农村'){
                    disable = income2 * t * age;
                    this.o1=income2;
            

                }
                this.result=disable;
                this.mental_fee=50000*t;
                this.on_off='';
                this.o2=t;
                this.o3=age;
                this.city1_income=income1;
                this.city2_income=income2;

                this.tableData[0].result= this.result+"("+this.o1+"*"+this.o2+"*"+this.o3+")";
                this.tableData[1].result=this.work_fee;
                this.tableData[2].result=this.nurse_fee;
                this.tableData[3].result=this.food_fee;
                this.tableData[4].result=this.nutrition_fee;
                this.tableData[5].result=this.traffic_fee;
                this.tableData[6].result=this.mental_fee;
                this.tableData[7].result=this.authenticate_fee;
                this.tableData[8].result=this.medical_fee;
                this.tableData[9].result=this.funeral_fee;
                this.tableData[10].result=this.maintenance;




 


                if(t==1){
                  
                    this.funeral_fee='上年度在岗职工平均工资(城镇)÷12个月×6个月';

                }
                else{
                   
                    this.funeral_fee=0;

                }
            },


            
            saveDataEvent(){

                var that=this
                var data= { 
                    whattodo: "updateTraffic",
                    param:this.param
                }
                this.axios.post('https://api.lawtip.cn/cal',data
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });

                        }else if (result.status=='ok'){
                        //    sessionStorage.setItem('traffic', JSON.stringify(result.data));
                            // this.params=result.data
                            that.$message({
                                message: '成功',
                                type: 'success'
                            });

                        }else if (result.status=='noresult'){
                            that.$message('没有查询到结果');
                        }


                        
                    }
                    
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                });
            },

            submitForm(formName) {
                window.console.log( this.$refs[formName])
                this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit!');
                } else {
                    window.console.log('error submit!!');
                    return false;
                }
                });
            },


            CalculateHandle(){


                // window.console.log(e)
                var that=this
                that.tableData=[]
                var form = this.form
                // console.log(this.data.param.people_need_raised_ages)
                // if (param.people_need_raised>0){
                //     param.people_need_raised_ages = this.data.param.people_need_raised_ages
                
                // }
                var data1=this.data1
            

                
                var param = this.param || ''
                if(param && this.useMine){  //使用自定义参数
                    form = Object.assign(form, param);

                }else  {
                    console.log("this.kind2:",this.kind2)
                    console.log('this.index2:',this.index2)
                    console.log('form.area:',form.area)
                     
                    console.log("this.kind2[this.index2]:",this.kind2[this.index2])
                    // form.ava_income = data1[this.kind2[this.index2]].ava_income1
                    // form.ava_consuming_fee = data1[this.kind2[this.index2]].ava_consuming_fee1
                    form.ava_income = data1[form.area].ava_income1
                    form.ava_consuming_fee = data1[form.area].ava_consuming_fee1
                    form.nurse_subsidy = 0
                    form.food_subsidy = 0
                    form.nutition_subsidy = 0
                    form.ava_wage = 0
                }
                var data= { 
                    whattodo: "calTraffic",
                    param:form
                }
                this.axios.post('https://api.lawtip.cn/cal',data
                ).then(function (res) {
                    window.console.log(res)
                    if(res.status==200){
                        let result=res.data
                        if(result.status=='badgate'){
                            that.$message({
                                message: '请先登录哦',
                                type: 'warning'
                            });

                        }else if (result.status=='ok'){
                        //    sessionStorage.setItem('traffic', JSON.stringify(result.data));
                            // this.params=result.data
                            let data=result.data
                            for(let p in data){
                                if(data[p]>0){
                                    let name
                                    if(p=='total'){name='合计'}
                                    else if(p=='comforting_compensation'){name='精神损失抚慰金'}
                                    else if(p=='food_compensation'){name='伙食费'}
                                    else if(p=='funeral_fee'){name='丧葬费'}
                                    else if(p=='injury_compensation'){name='伤残赔偿金'}
                                    else if(p=='nurse_compensation'){name='护理费'}
                                    else if(p=='nutrition_compensation'){name='营养费'}
                                    else if(p=='raising_compensation'){name='被扶养人生活费'}
                                    else if(p=='work_compensation'){name='误工费'}
                                    else if(p=='medical_fee'){name='医疗费'}
                                    if(name){
                                        that.tableData.push({name:name,result:data[p]})
                                    }
                                    

                                }
                                //  that.tableData.push({name:p,result:data[p]})
                            }
                            that.$message({
                                message: '成功',
                                type: 'success'
                            });

                        }else if (result.status=='noresult'){
                            that.$message('没有查询到结果');
                        }


                        
                    }
                    
                
                    
                }).catch(function (error) {
                    window.console.log(error);
                });

                // // param = Object.assign(param, this.data.param);
                // console.log('param:', param)

                // wx.request({
                // url: "https://api.lawtip.cn/cal",
                // method: "POST",
                // data: {
                //     whattodo: 'calTraffic',
                //     token: app.globalData.token,
                //     param:param
                // },
                // header: {
                //     "Content-Type": "application/json"
                // },
                // success: function (res) {
                //     console.log(res.data)
                //     if (res.data.status == 'ok') {
                //     that.setData({
                //         _param:param,
                //         result:res.data.data
                //     })
                //     }




                // },
            // })
                },

     
        
    }
}
</script>

<style >


.addParam{
    margin-top:50px;
    width:100%;
    /* border:1.5px solid #dedede; */
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    /* position: relative; */
    align-content: center;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    
}
.addParam span,i{
 
    margin-right:10px;
  
}
.addParam i{
    /* border:1.5px solid #dedede; */
    line-height: 30px;
    font-size:26px;
}
.guide{
  /* font-size:22rpx; */
  float: right;
  /* padding-right: 20rpx; */
  text-decoration: underline;
  margin-right: 20px;
  color: rgb(19, 109, 145);
  cursor: pointer;
}


</style>
